<vt-styled-authorization-page [content]="twoFactorForm"></vt-styled-authorization-page>

<ng-template #twoFactorForm>
    <vt-two-factor-form
        (submitted)="onSubmit($event)"
        (sendTwoFactorCode)="onSendTwoFactorCode()"
        [errorMessage]="error$ | async"
        [loginResponse]="loginResponse$ | async">
    </vt-two-factor-form>
</ng-template>